import angular from 'angular'
import ScheduleCalendarComponent from './schedule-calendar.component'
import { EventEditModalComponent } from './modals/event-edit-modal.component'
import { OverlapConflictModalComponent } from './modals/overlap-conflict-modal.component'
import { CreateIntervalModalComponent } from './modals/create-interval-modal.component'

import SceneCollectionService from 'common/scenecollection.service'

export default angular
  .module('scheduleCalendar', [
    SceneCollectionService
  ])
  .component('scheduleCalendar', ScheduleCalendarComponent)
  .component('eventEditModal', EventEditModalComponent)
  .component('overlapConflictModal', OverlapConflictModalComponent)
  .component('createIntervalModal', CreateIntervalModalComponent)
  .name
